import Hero from "./Hero";
import TrustStrip from "./TrustStrip";
import FeaturedTours from "./FeaturedTours";
import WhyBand from "./WhyBand";
import Stats from "./Stats";
import Destinations from "./Destinations";
import Testimonial from "./Testimonial";
import Cta from "./Cta";

function Home() {
  return (
    <div>
      <Hero />
      <TrustStrip />
      <FeaturedTours />
      <WhyBand />
      <Stats />
      <Destinations />
      <Testimonial />
      <Cta />
    </div>
  );
}

export default Home;
